/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'goal-actions.archive-goal.generic-error-title': 'Could not archive goal',
  'goal-actions.copy-goal.cancel': 'Cancel',
  'goal-actions.copy-goal.close-modal': 'Close Modal',
  'goal-actions.copy-goal.error': "Give your goal a name so everyone knows what it's about",
  'goal-actions.copy-goal.failed-description': 'There was an error cloning the goal. Please try again later.',
  'goal-actions.copy-goal.failed-description-forbidden': 'You do not have permission to copy this goal.',
  'goal-actions.copy-goal.failed-title': "We couldn't clone this goal.",
  'goal-actions.copy-goal.followers': 'Followers',
  'goal-actions.copy-goal.goal-name': 'Goal name',
  'goal-actions.copy-goal.include': 'Include',
  'goal-actions.copy-goal.links': 'Links',
  'goal-actions.copy-goal.submit': 'Submit',
  'goal-actions.copy-goal.success-description': 'The goal has been cloned successfully.',
  'goal-actions.copy-goal.success-link': 'View cloned goal.',
  'goal-actions.copy-goal.success-title': 'Goal {goalName} cloned.',
  'goal-actions.copy-goal.title': 'Copy goal',
  'goal-actions.follow-goal.follow-error-title': 'Could not follow goal',
  'goal-actions.follow-goal.unfollow-error-title': 'Could not unfollow goal',
  'goal-actions.goal-actions.archive-error-title': 'goal could not be restored',
  'goal-actions.goal-actions.archive-goal': 'Archive goal',
  'goal-actions.goal-actions.archive-restore-error-description':
    'goal changes could not be saved. Please try again later.',
  'goal-actions.goal-actions.copy-goal': 'Copy goal',
  'goal-actions.goal-actions.copy-link': 'Copy link',
  'goal-actions.goal-actions.follow': 'Follow',
  'goal-actions.goal-actions.generic-error-description': 'Something went wrong, try again in a few minutes.',
  'goal-actions.goal-actions.restore-goal': 'Restore goal',
  'goal-actions.goal-actions.share': 'Share',
  'goal-actions.goal-actions.show-more': 'Show more',
  'goal-actions.goal-actions.unfollow': 'Unfollow',
  'goal-actions.goal-content.follow-confirmation-description':
    "We'll send you a digest containing the updates of all goals you're following in the first week of next month.",
  'goal-actions.goal-content.follow-confirmation-title': "🙌🏼 You're now following this goal!",
  'goal-actions.restore-goal.generic-error-title': 'Could not restore goal',
};
